import { render, staticRenderFns } from "./failPage.vue?vue&type=template&id=f7d2d7d6&scoped=true"
import script from "./failPage.vue?vue&type=script&lang=js"
export * from "./failPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d2d7d6",
  null
  
)

export default component.exports